// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <manage-workspace :id="this.$route.params.id" v-if="!!(this.$route.params.id)" />
  <manage-workspaces v-else />
</template>

<script>
import ManageWorkspace from './ManageWorkspace.vue'
import ManageWorkspaces from './ManageWorkspaces.vue'

export default {
  name: 'Manage',
  components: {
    ManageWorkspace,
    ManageWorkspaces
  }
}
</script>
